import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";
import MediaItemDownloadInfo from "~/models/Media/MediaItemDownloadInfo";

@observer
class MediaItemDownloadInfoSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clicked: false,
    };
  }

  render() {
    const { mediaItemDownloadInfo, t, token, useShortFilenames } = this.props;
    const { clicked } = this.state;

    let { downloadUrl } = mediaItemDownloadInfo;

    if (!/^https?:\/\//.test(downloadUrl)) {
      downloadUrl = `${window.location.protocol}//${window.location.host}${downloadUrl}`;
    }

    downloadUrl = new URL(downloadUrl);

    if (token) {
      downloadUrl.searchParams.append("token", token);
    }

    if (useShortFilenames) {
      downloadUrl.searchParams.append("useShortFilename", 1);
    }

    return (
      <div className="media-item-download-info">
        <Icon name={clicked ? "checkmark" : "download"} size="small" />
        <a
          title={`(${mediaItemDownloadInfo.description})`}
          href={downloadUrl}
          onClick={() => {
            this.setState({ clicked: true });
          }}
        >
          {t(mediaItemDownloadInfo.title)}
        </a>
      </div>
    );
  }
}

MediaItemDownloadInfoSection.propTypes = {
  mediaItemDownloadInfo: PropTypes.instanceOf(MediaItemDownloadInfo),
  t: PropTypes.func.isRequired,
  token: PropTypes.string,
  useShortFilenames: PropTypes.bool,
};

export default withTranslation()(MediaItemDownloadInfoSection);
